import { render, staticRenderFns } from "./return_goods_detail.vue?vue&type=template&id=770cb1ab&scoped=true&"
import script from "./return_goods_detail.vue?vue&type=script&lang=js&"
export * from "./return_goods_detail.vue?vue&type=script&lang=js&"
import style0 from "./return_goods_detail.vue?vue&type=style&index=0&id=770cb1ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770cb1ab",
  null
  
)

export default component.exports